import { Checkbox } from '@material-ui/core';
import {
  getProfilePreferences,
  updateProfilePreferencesIndivudual,
} from '@webapps/business';
import {
  useAuth,
  useMutation,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../theme';

const {
  colors: { addressColor, nameColor },
} = theme;

const Preferences = () => {
  const { classes, global, cx, } = useStyles(styles);

  const { idUser } = useAuth();

  const {
    data: preferences = {},
    refetch: refetchProfilPreference,
    isLoading,
  } = useQuery(getProfilePreferences, {
    key: 'preferences',
    variables: { id: idUser },
  });

  const {
    // error,
    // isLoading,
    isSuccess: isSuccessUpdatePreference,
    mutateAsync: mutateUpdatePreferences,
  } = useMutation(updateProfilePreferencesIndivudual);

  const handleSetMailAlert = async (e, id) => {
    await mutateUpdatePreferences({
      type: 'email_alert',
      status: e.target.checked,
      id,
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSetSMSAlert = async (e, id) => {
    await mutateUpdatePreferences({
      status: e.target.checked,
      type: 'sms_alert',
      id,
    });
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSetCartAlert = async (e, id) => {
    await mutateUpdatePreferences({
      type: 'my_cart_alert',
      status: e.target.checked,
      id,
    });
  };

  useEffect(() => {
    if (isSuccessUpdatePreference) {
      refetchProfilPreference();
    }
  }, [isSuccessUpdatePreference]);

  return (
    !isLoading && (
      <div>
        <div className={global.title}>
          <FormattedMessage id="student.souscription.preference.title" />
        </div>
        <div className={cx(global.infoText, classes.itemPref)}>
          <Checkbox
            checked={preferences?.emailAlert}
            color="primary"
            onChange={(e) => handleSetMailAlert(e, idUser)}
            size="small"
          />
          <div className={cx(global.infoText, classes.text)}>
            <FormattedMessage id="student.souscription.preference.mail" />
          </div>
        </div>
        {/* <div className={cx(global.infoText, classes.itemPref)}>
      <Checkbox
        checked={preferences?.smsAlert}
        color="primary"
        onChange={(e) => handleSetSMSAlert(e, idUser)}
        size="small"
      />
      <div className={cx(global.infoText, classes.text)}>
        <FormattedMessage id="student.souscription.preference.sms" />
      </div>
    </div>
    <div className={cx(global.infoText, classes.itemPref)}>
      <Checkbox
        checked={preferences?.myCartAlert}
        color="primary"
        onChange={(e) => handleSetCartAlert(e, idUser)}
        size="small"
      />
      <div className={cx(global.infoText, classes.text)}>
        <FormattedMessage id="student.souscription.preference.carte" />
      </div>
    </div> */}
      </div>
    )
  );
};

const styles = ({ spacing }) => ({
  profilName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing(2),
  },
  avatar: {
    height: 60,
    width: 60,
  },
  text: {
    paddingLeft: 0,
  },
  gridContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemPref: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default Preferences;
